import type { IBookPreview } from '@shared/jp/data/products';
import {
  BOOK_PRICE_FROEBELKAN_ALPHABET_TRAIN,
  BOOK_PRICE_FROEBELKAN_ALPHABET_TRAIN_HARD_COVER,
  INPUT_NAME_KUN_CHAN,
  INPUT_VALUE_BIKE,
  INPUT_VALUE_HAIR_STYLE_BOB,
  INPUT_VALUE_HAIR_STYLE_HAT,
  INPUT_VALUE_HAIR_STYLE_LONG,
  INPUT_VALUE_HAIR_STYLE_SHORT,
  INPUT_VALUE_HAIR_STYLE_SIDE,
  INPUT_VALUE_HAIR_STYLE_TWIN,
  INPUT_VALUE_KUN_CHAN_NASHI,
  INPUT_VALUE_PLANE,
  INPUT_VALUE_TRAIN,
  kunChanArr,
  KUNCHAN_VALUE_TO_LABEL_MAP,
  hairStyleAlphabetTrain,
} from '@shared/jp/product';
import {
  INPUT_VALUE_COVER_TYPE_HARD,
  INPUT_VALUE_COVER_TYPE_SOFT,
  INPUT_NAME_GLASSES,
  INPUT_NAME_HAIR_COLOR,
  INPUT_NAME_HAIR_STYLE,
  INPUT_NAME_KIDS_NAME,
  INPUT_NAME_SKIN_COLOR,
  INPUT_VALUE_HAIR_COLOR_BLACK,
  INPUT_VALUE_HAIR_COLOR_BLONDE,
  INPUT_VALUE_HAIR_COLOR_BROWN,
  INPUT_VALUE_HAIR_COLOR_RED,
  INPUT_VALUE_SKIN_COLOR_BLACK,
  INPUT_VALUE_SKIN_COLOR_BROWN,
  INPUT_VALUE_SKIN_COLOR_NUTMEG,
  INPUT_VALUE_SKIN_COLOR_WHITE,
} from '@shared/common/product';
import {
  EBannerTextColor,
  PURPOSE_ADVENTURE,
  PURPOSE_BIRTH_GIFT,
} from '@shared/common/data/products';
import { getPriceData } from '@shared/jp/data/products';
import {
  INPUT_NAME_RESERVED_CANVAS1,
  getCheckboxInputData,
  bookInputShowWhen,
  bookInputsToNameValueMap,
  getSelectInputOptionData,
  getSelectInputData,
  getRadioColorInputData,
  getRadioColorInputOptionData,
  getTextInputData,
  getCanvasInputData,
  getRadioIconInputData,
  getRadioIconInputOptionData,
  getRadioInputData,
  getRadioInputOptionData,
} from '@shared/common/data/inputs';
import {
  getNameValidatorList,
  GET_BOOK_NAME_ERROR,
} from '@shared/jp/data/inputs';
import type { ICanvasInputItem } from '@shared/common/data/inputs';
import type { THairColor, TSkinColor } from '@shared/common/product';
import type {
  THairStyleFroebelkanAlphabetTrain,
  TVehicle,
} from '@shared/jp/product';
import AlphabetTrainShared from '@shared/jp/vendors/froebelkan/data/products/books/AlphabetTrainShared';
import { getCoverHard, getCoverSoft } from './_utils';

export const AlphabetTrainInputsKidsName = getTextInputData({
  label: '子どもの下の名前',
  placeholder: 'ひらがな7文字まで',
  name: INPUT_NAME_KIDS_NAME,
  validator: getNameValidatorList(7, 2),
  error: GET_BOOK_NAME_ERROR(7),
} as const);

export const AlphabetTrainInputsKunChan = getSelectInputData({
  label: 'くん・ちゃん付け',
  placeholder: '選んでください',
  options: kunChanArr.map((value) =>
    getSelectInputOptionData({
      label: KUNCHAN_VALUE_TO_LABEL_MAP[value],
      value,
    }),
  ),
  value: INPUT_VALUE_KUN_CHAN_NASHI,
  name: INPUT_NAME_KUN_CHAN,
} as const);

export const AlphabetTrainInputsSkinColor = getRadioColorInputData({
  label: '肌色',
  options: [
    getRadioColorInputOptionData({
      color: '#FFEAD6',
      value: INPUT_VALUE_SKIN_COLOR_WHITE,
    }),
    getRadioColorInputOptionData({
      color: '#FAD5A2',
      value: INPUT_VALUE_SKIN_COLOR_NUTMEG,
    }),
    getRadioColorInputOptionData({
      color: '#CF9970',
      value: INPUT_VALUE_SKIN_COLOR_BROWN,
    }),
    getRadioColorInputOptionData({
      color: '#B28262',
      value: INPUT_VALUE_SKIN_COLOR_BLACK,
    }),
  ],
  value: INPUT_VALUE_SKIN_COLOR_WHITE,
  name: INPUT_NAME_SKIN_COLOR,
});

export const AlphabetTrainInputsHairColor = getRadioColorInputData({
  label: 'かみ色',
  options: [
    getRadioColorInputOptionData({
      color: '#F8D992',
      value: INPUT_VALUE_HAIR_COLOR_BLONDE,
    }),
    getRadioColorInputOptionData({
      color: '#CF744B',
      value: INPUT_VALUE_HAIR_COLOR_RED,
    }),
    getRadioColorInputOptionData({
      color: '#9F6D48',
      value: INPUT_VALUE_HAIR_COLOR_BROWN,
    }),
    getRadioColorInputOptionData({
      color: '#4D423B',
      value: INPUT_VALUE_HAIR_COLOR_BLACK,
    }),
  ],
  value: INPUT_VALUE_HAIR_COLOR_BLACK,
  name: INPUT_NAME_HAIR_COLOR,
});

export const AlphabetTrainInputsHairStyleBike = getRadioIconInputData({
  label: 'かみ型',
  options: hairStyleAlphabetTrain.map((value) =>
    getRadioIconInputOptionData({
      imgSrc: `assets/images/at-canvas/bike/hair-style/${value}.png`,
      value,
    }),
  ),
  value: INPUT_VALUE_HAIR_STYLE_SHORT,
  name: INPUT_NAME_HAIR_STYLE,
});

export const AlphabetTrainInputsHairStylePlane = getRadioIconInputData({
  label: 'かみ型',
  options: hairStyleAlphabetTrain.map((value) =>
    getRadioIconInputOptionData({
      imgSrc: `assets/images/at-canvas/plane/hair-style/${value}.png`,
      value,
    }),
  ),
  value: INPUT_VALUE_HAIR_STYLE_SHORT,
  name: INPUT_NAME_HAIR_STYLE,
});

export const AlphabetTrainInputsHairStyleTrain = getRadioIconInputData({
  label: 'かみ型',
  options: hairStyleAlphabetTrain.map((value) =>
    getRadioIconInputOptionData({
      imgSrc: `assets/images/at-canvas/train/hair-style/${value}.png`,
      value,
    }),
  ),
  value: INPUT_VALUE_HAIR_STYLE_SHORT,
  name: INPUT_NAME_HAIR_STYLE,
});

export const AlphabetTrainInputsVehicle = getRadioInputData({
  label: 'のりもの（１つ選択）',
  options: [
    getRadioInputOptionData({
      label: 'おもちゃごう',
      value: INPUT_VALUE_TRAIN,
    }),
    getRadioInputOptionData({
      label: 'バギー',
      value: INPUT_VALUE_BIKE,
    }),
    getRadioInputOptionData({
      label: 'ロケット',
      value: INPUT_VALUE_PLANE,
    }),
  ],
  value: '',
  name: 'vehicle',
});

export const AlphabetTrainInputsGlasses = getCheckboxInputData({
  label: 'メガネをかける',
  name: INPUT_NAME_GLASSES,
  value: false,
} as const);

const AlphabetTrainInputsCanvasInputs = [
  AlphabetTrainInputsSkinColor,
  AlphabetTrainInputsHairColor,
];

const AlphabetTrainInputsCanvasInputsTrain = [
  ...AlphabetTrainInputsCanvasInputs,
  AlphabetTrainInputsHairStyleTrain,
  AlphabetTrainInputsGlasses,
];

const AlphabetTrainInputsCanvasInputsBike = [
  ...AlphabetTrainInputsCanvasInputs,
  AlphabetTrainInputsHairStyleBike,
  AlphabetTrainInputsGlasses,
];

const AlphabetTrainInputsCanvasInputsPlane = [
  ...AlphabetTrainInputsCanvasInputs,
  AlphabetTrainInputsHairStylePlane,
  AlphabetTrainInputsGlasses,
];

const AlphabetTrainItemsSkinTrain: ICanvasInputItem[] = [
  {
    imgSrc: 'assets/images/at-canvas/train/M/icon-M1.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsSkinColor,
        condition: (v: TSkinColor) => v === INPUT_VALUE_SKIN_COLOR_WHITE,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/train/M/icon-M2.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsSkinColor,
        condition: (v: TSkinColor) => v === INPUT_VALUE_SKIN_COLOR_NUTMEG,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/train/M/icon-M3.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsSkinColor,
        condition: (v: TSkinColor) => v === INPUT_VALUE_SKIN_COLOR_BROWN,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/train/M/icon-M4.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsSkinColor,
        condition: (v: TSkinColor) => v === INPUT_VALUE_SKIN_COLOR_BLACK,
      },
    ],
  },
];

const AlphabetTrainItemsSkinBike = AlphabetTrainItemsSkinTrain.map(
  (_item, index) => ({
    ..._item,
    imgSrc: `assets/images/at-canvas/bike/M/icon-M${index + 1}.png`,
  }),
);

const AlphabetTrainItemsSkinPlane = AlphabetTrainItemsSkinTrain.map(
  (_item, index) => ({
    ..._item,
    imgSrc: `assets/images/at-canvas/plane/M/icon-M${index + 1}.png`,
  }),
);

const AlphabetTrainItemsHairTrain: ICanvasInputItem[] = [
  {
    imgSrc: 'assets/images/at-canvas/train/H/icon-H1.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleTrain,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_HAT,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/train/H/icon-H2.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleTrain,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_SHORT,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/train/H/icon-H3.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleTrain,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_SIDE,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/train/H/icon-H4.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleTrain,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_TWIN,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/train/H/icon-H5.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleTrain,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_BOB,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/train/H/icon-H6.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleTrain,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_LONG,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/train/H/icon-H7.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleTrain,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_HAT,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/train/H/icon-H8.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleTrain,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_SHORT,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/train/H/icon-H9.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleTrain,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_SIDE,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/train/H/icon-H10.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleTrain,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_TWIN,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/train/H/icon-H11.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleTrain,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_BOB,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/train/H/icon-H12.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleTrain,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_LONG,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/train/H/icon-H13.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleTrain,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_HAT,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/train/H/icon-H14.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleTrain,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_SHORT,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/train/H/icon-H15.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleTrain,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_SIDE,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/train/H/icon-H16.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleTrain,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_TWIN,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/train/H/icon-H17.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleTrain,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_BOB,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/train/H/icon-H18.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleTrain,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_LONG,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/train/H/icon-H19.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleTrain,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_HAT,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/train/H/icon-H20.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleTrain,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_SHORT,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/train/H/icon-H21.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleTrain,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_SIDE,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/train/H/icon-H22.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleTrain,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_TWIN,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/train/H/icon-H23.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleTrain,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_BOB,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/train/H/icon-H24.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleTrain,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_LONG,
      },
    ],
  },
];

const AlphabetTrainItemsHairBike: ICanvasInputItem[] = [
  {
    imgSrc: 'assets/images/at-canvas/bike/H/icon-H1.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleBike,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_HAT,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/bike/H/icon-H2.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleBike,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_SHORT,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/bike/H/icon-H3.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleBike,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_SIDE,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/bike/H/icon-H4.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleBike,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_TWIN,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/bike/H/icon-H5.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleBike,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_BOB,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/bike/H/icon-H6.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleBike,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_LONG,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/bike/H/icon-H7.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleBike,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_HAT,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/bike/H/icon-H8.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleBike,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_SHORT,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/bike/H/icon-H9.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleBike,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_SIDE,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/bike/H/icon-H10.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleBike,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_TWIN,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/bike/H/icon-H11.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleBike,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_BOB,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/bike/H/icon-H12.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleBike,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_LONG,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/bike/H/icon-H13.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleBike,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_HAT,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/bike/H/icon-H14.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleBike,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_SHORT,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/bike/H/icon-H15.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleBike,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_SIDE,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/bike/H/icon-H16.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleBike,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_TWIN,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/bike/H/icon-H17.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleBike,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_BOB,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/bike/H/icon-H18.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleBike,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_LONG,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/bike/H/icon-H19.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleBike,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_HAT,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/bike/H/icon-H20.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleBike,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_SHORT,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/bike/H/icon-H21.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleBike,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_SIDE,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/bike/H/icon-H22.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleBike,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_TWIN,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/bike/H/icon-H23.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleBike,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_BOB,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/bike/H/icon-H24.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStyleBike,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_LONG,
      },
    ],
  },
];

const AlphabetTrainItemsHairPlane: ICanvasInputItem[] = [
  {
    imgSrc: 'assets/images/at-canvas/plane/H/icon-H1.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStylePlane,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_HAT,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/plane/H/icon-H2.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStylePlane,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_SHORT,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/plane/H/icon-H3.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStylePlane,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_SIDE,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/plane/H/icon-H4.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStylePlane,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_TWIN,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/plane/H/icon-H5.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStylePlane,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_BOB,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/plane/H/icon-H6.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStylePlane,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_LONG,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/plane/H/icon-H7.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStylePlane,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_HAT,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/plane/H/icon-H8.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStylePlane,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_SHORT,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/plane/H/icon-H9.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStylePlane,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_SIDE,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/plane/H/icon-H10.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStylePlane,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_TWIN,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/plane/H/icon-H11.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStylePlane,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_BOB,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/plane/H/icon-H12.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStylePlane,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_LONG,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/plane/H/icon-H13.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStylePlane,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_HAT,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/plane/H/icon-H14.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStylePlane,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_SHORT,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/plane/H/icon-H15.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStylePlane,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_SIDE,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/plane/H/icon-H16.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStylePlane,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_TWIN,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/plane/H/icon-H17.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStylePlane,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_BOB,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/plane/H/icon-H18.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStylePlane,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_LONG,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/plane/H/icon-H19.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStylePlane,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_HAT,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/plane/H/icon-H20.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStylePlane,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_SHORT,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/plane/H/icon-H21.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStylePlane,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_SIDE,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/plane/H/icon-H22.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStylePlane,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_TWIN,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/plane/H/icon-H23.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStylePlane,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_BOB,
      },
    ],
  },
  {
    imgSrc: 'assets/images/at-canvas/plane/H/icon-H24.png',
    showWhen: [
      {
        inputToCheck: AlphabetTrainInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: AlphabetTrainInputsHairStylePlane,
        condition: (v: THairStyleFroebelkanAlphabetTrain) =>
          v === INPUT_VALUE_HAIR_STYLE_LONG,
      },
    ],
  },
];

export const AlphabetTrainInputsCanvasTrain = {
  // width: 360,
  // height: 500,
  // crop: {
  //   top: 10,
  //   right: 15,
  //   bottom: 10,
  //   left: 10,
  // },
  width: 237,
  height: 290,
  name: INPUT_NAME_RESERVED_CANVAS1,
};

export const AlphabetTrainInputsCanvasBike = {
  // width: 300,
  // height: 400,
  // crop: {
  //   top: 70,
  //   right: 10,
  //   bottom: 20,
  //   left: 20,
  // },
  width: 237,
  height: 290,
  name: INPUT_NAME_RESERVED_CANVAS1,
};

export const AlphabetTrainInputsCanvasPlane = {
  width: 237,
  height: 290,
  // crop: {
  //   top: 70,
  //   right: 10,
  //   bottom: 55,
  //   left: 10,
  // },
  name: INPUT_NAME_RESERVED_CANVAS1,
};

export const AlphabetTrainInputsCanvasBabyTrain = getCanvasInputData({
  ...AlphabetTrainInputsCanvasTrain,
  name: INPUT_NAME_RESERVED_CANVAS1 as typeof INPUT_NAME_RESERVED_CANVAS1,
  label: '子どもにそっくりの主人公を作りましょう！',
  inputs: AlphabetTrainInputsCanvasInputsTrain,
  items: [
    ...AlphabetTrainItemsSkinTrain,
    ...AlphabetTrainItemsHairTrain,
    {
      imgSrc: 'assets/images/at-canvas/train/G/icon-G01.png',
      showWhen: [
        {
          inputToCheck: AlphabetTrainInputsGlasses,
          condition: (v: boolean) => v,
        },
      ],
    },
  ],
  value: bookInputsToNameValueMap(AlphabetTrainInputsCanvasInputsTrain),
});

export const AlphabetTrainInputsCanvasBabyBike = getCanvasInputData({
  ...AlphabetTrainInputsCanvasBike,
  name: INPUT_NAME_RESERVED_CANVAS1 as typeof INPUT_NAME_RESERVED_CANVAS1,
  label: '子どもにそっくりの主人公を作りましょう！',
  inputs: AlphabetTrainInputsCanvasInputsBike,
  items: [
    ...AlphabetTrainItemsSkinBike,
    ...AlphabetTrainItemsHairBike,
    {
      imgSrc: 'assets/images/at-canvas/bike/G/icon-G02.png',
      showWhen: [
        {
          inputToCheck: AlphabetTrainInputsGlasses,
          condition: (v: boolean) => v,
        },
      ],
    },
  ],
  value: bookInputsToNameValueMap(AlphabetTrainInputsCanvasInputsBike),
});

export const AlphabetTrainInputsCanvasBabyPlane = getCanvasInputData({
  ...AlphabetTrainInputsCanvasPlane,
  name: INPUT_NAME_RESERVED_CANVAS1 as typeof INPUT_NAME_RESERVED_CANVAS1,
  label: '子どもにそっくりの主人公を作りましょう！',
  inputs: AlphabetTrainInputsCanvasInputsPlane,
  items: [
    ...AlphabetTrainItemsSkinPlane,
    ...AlphabetTrainItemsHairPlane,
    {
      imgSrc: 'assets/images/at-canvas/plane/G/icon-G03.png',
      showWhen: [
        {
          inputToCheck: AlphabetTrainInputsGlasses,
          condition: (v: boolean) => v,
        },
      ],
    },
  ],
  value: bookInputsToNameValueMap(AlphabetTrainInputsCanvasInputsPlane),
});

const prices = {
  [INPUT_VALUE_COVER_TYPE_SOFT]: getPriceData(
    BOOK_PRICE_FROEBELKAN_ALPHABET_TRAIN,
  ),
  [INPUT_VALUE_COVER_TYPE_HARD]: getPriceData(
    BOOK_PRICE_FROEBELKAN_ALPHABET_TRAIN_HARD_COVER,
  ),
} as const;

bookInputShowWhen(
  AlphabetTrainInputsCanvasBabyTrain,
  AlphabetTrainInputsVehicle,
  (vehicle: TVehicle) => vehicle === INPUT_VALUE_TRAIN,
);

bookInputShowWhen(
  AlphabetTrainInputsCanvasBabyBike,
  AlphabetTrainInputsVehicle,
  (vehicle: TVehicle) => vehicle === INPUT_VALUE_BIKE,
);

bookInputShowWhen(
  AlphabetTrainInputsCanvasBabyPlane,
  AlphabetTrainInputsVehicle,
  (vehicle: TVehicle) => vehicle === INPUT_VALUE_PLANE,
);

const coverSoft = getCoverSoft({
  price: prices[INPUT_VALUE_COVER_TYPE_SOFT],
  carousel: [
    'assets/images/covers/alphabettrain/SC01.jpg',
    'assets/images/covers/alphabettrain/SC02.jpg',
    'assets/images/covers/alphabettrain/SC03.jpg',
  ],
});
const coverHard = getCoverHard({
  price: prices[INPUT_VALUE_COVER_TYPE_HARD],
  carousel: [
    'assets/images/covers/alphabettrain/HC01.jpg',
    'assets/images/covers/alphabettrain/HC02.jpg',
    'assets/images/covers/alphabettrain/HC03.jpg',
  ],
});

const AlphabetTrain: IBookPreview = {
  ...AlphabetTrainShared,
  caption: 'おなまえさがして　<br class="hidden">あいうえおもちゃごう',
  summary:
    'お名前の文字、どこにあるかな？「あいうえお」から「わをん」の頭文字で始まるページの中に、お名前の文字が隠れている！？あいうえおもちゃごうといっしょに、自分のお名前を探す旅に出よう！',
  prices: [
    [INPUT_VALUE_COVER_TYPE_SOFT, prices[INPUT_VALUE_COVER_TYPE_SOFT]],
    [INPUT_VALUE_COVER_TYPE_HARD, prices[INPUT_VALUE_COVER_TYPE_HARD]],
  ],
  photos: [
    'assets/images/carouselAT-01.jpg',
    'assets/images/carouselAT-02.png',
    'assets/images/carouselAT-03.jpg',
    'assets/images/carouselAT-04.jpg',
    'assets/images/carouselAT-05.png',
  ],
  menuPhoto: 'assets/images/BK2-sample.png',
  previewPhoto: 'assets/images/BK2-sample.png',
  // TODO
  properties: {
    purpose: [PURPOSE_ADVENTURE, PURPOSE_BIRTH_GIFT],
    age: {
      start: 0,
      end: 3,
    },
  },
  notice: {
    caption:
      'お子さまのお名前とアバター、写真と伝えたいメッセージをカスタマイズして、特別な１冊を作りましょう！',
    description:
      'お名前の文字、どこにあるかな？「あいうえお」から「わをん」の頭文字で始まるページの中に、お名前の文字が隠れている！？あいうえおもちゃごうといっしょに、自分のお名前を探す旅に出よう！',
    points: [
      {
        imgSrc: 'assets/images/welcome-notice-point-age.png',
        caption: '1〜8歳におすすめ',
      },
      {
        imgSrc: 'assets/images/welcome-notice-point-scene.png',
        caption: '知育や学びにも',
      },
    ],
  },
  points: [
    {
      caption: 'どんなカスタムができるの？',
      description:
        '・主人公の名前を入れる<br>・主人公に似たアバターをつくる<br>・主人公の名前で探すひらがなが変わる<br>・メッセージを入れる<br>・写真を入れる',
    },
    {
      caption: '絵本のストーリーは？',
      description:
        'お名前の文字、どこにあるかな？「あいうえお」から「わをん」の頭文字で始まるページの中に、お名前の文字が隠れている！？<br>あいうえおもちゃごうといっしょに、自分のお名前を探す旅に出よう！',
    },
    {
      caption: 'ページ数や絵本の大きさは？',
      description:
        '全ての絵本は1冊ずつ、ご注文を受けてからオーダーメイドで印刷・製本されます。高級感のある、環境に配慮した用紙を使用しています。<br><br><b>・全32ページ<br>・21cm×21cm（本文部分）の正方形<br>・日本国内で製造</b>',
    },
  ],
  inputs: [
    AlphabetTrainInputsKidsName,
    AlphabetTrainInputsKunChan,
    AlphabetTrainInputsVehicle,
    AlphabetTrainInputsCanvasBabyTrain,
    AlphabetTrainInputsCanvasBabyBike,
    AlphabetTrainInputsCanvasBabyPlane,
  ],
  banner: {
    imgSrc: 'assets/images/bk3-banner-desktop-JP.jpg',
    imgSrcLtMd: 'assets/images/bk3-banner-mobile-JP.jpg',
    text: 'TODO',
    textColor: EBannerTextColor.dark,
  },
  description: [],
  review: {
    text: [
      'カラフルなイラストがたくさんあってあきない！お話があいうえお作文になっているのも驚きです',
    ],
  },
  reviews: [],
  options: {
    [INPUT_VALUE_COVER_TYPE_HARD]: coverHard,
    [INPUT_VALUE_COVER_TYPE_SOFT]: coverSoft,
  },
  option: INPUT_VALUE_COVER_TYPE_SOFT,
  popularity: 15,
  createdAt: new Date('2020-01-03'),
};

export default AlphabetTrain;
